module.exports = __webpack_public_path__ + "static/the-dream-machine-9043cf6e47d2c8c45d5e151a6e0b7032.jpg";